import styles from '../styles/strategy.module.scss'
import strategy from '../data/strategy.json';

function StrategyTips() {

  return (
    <div className={styles.strategy}>
      <h3>{strategy.title}</h3>
      <ul>
        {
          strategy.body.map((s, i) =>
            <li key={i} >
              <span>{s.subtitle}</span><p>{s.main}</p>
            </li>
          )
        }
      </ul>
      <div className={styles.throws}>
        <div className={styles.item}>
          <h3 className={styles.throw}>Throws</h3>
          <h3 className={styles.way}>Best Ways of Playing Opening Rolls</h3>
        </div>
      {
        strategy.rolls.map((r, i) =>
          <div className={styles.item} key={i}>
            <span className={styles.throw}>{r.throw}</span>
            <p className={styles.way}>{r.way}</p>
          </div>
        )
      }
      </div>
    </div>
  )
}

export default StrategyTips
